var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":"black"},on:{"click":function($event){return _vm.$emit('showExpandedDialog')}}},[_vm._v(" mdi-fullscreen ")])}
var staticRenderFns = []

export { render, staticRenderFns }